import React from 'react';
import './LoginInfo.css';

interface LoginInfoProps {
  onClose: () => void;
}

const LoginInfo: React.FC<LoginInfoProps> = ({ onClose }) => {
  return (
    <div className="login-info-overlay">
      <div className="login-info-modal">
        <div className="login-info-header">
          <h3>默认登录凭据</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="login-info-content">
          <div className="login-credentials">
            <h4>管理员账户：</h4>
            <p><strong>用户名：</strong> admin</p>
            <p><strong>密码：</strong> admin123</p>
          </div>
          <div className="login-credentials">
            <h4>普通用户：</h4>
            <p><strong>用户名：</strong> user</p>
            <p><strong>密码：</strong> user123</p>
          </div>
          <div className="login-info-note">
            <p><strong>注意：</strong>这些是开发环境的默认凭据，生产环境请修改密码。</p>
          </div>
        </div>
        <div className="login-info-footer">
          <button className="btn-primary" onClick={onClose}>知道了</button>
        </div>
      </div>
    </div>
  );
};

export default LoginInfo;
